export { default } from './ProviderDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderDetail/index.js